import { motion } from 'framer-motion';
import { safeInvoke, isTauri } from '@/utils/tauri';

export const CloseButton = () => {
  // 在浏览器环境中不显示关闭按钮
  if (!isTauri()) {
    return null;
  }

  const handleClose = async () => {
    try {
      // 先滑出窗口
      await safeInvoke('slide_out_and_hide');
      // 延迟后隐藏窗口（给动画时间）
      setTimeout(async () => {
        await safeInvoke('set_window_visible', { visible: false });
      }, 300);
    } catch (error) {
      console.error('关闭窗口失败:', error);
    }
  };

  return (
    <motion.button
      onClick={handleClose}
      className="absolute top-3 right-3 w-7 h-7 rounded-full bg-red-500 hover:bg-red-600 flex items-center justify-center text-white text-sm font-bold transition-colors z-50 shadow-lg"
      title="关闭"
    >
      ×
    </motion.button>
  );
};

